<div class="chat-history" (scroll)="onScroll($event)" (click)="handleClick($event)">
        <div *ngIf="groupedMessages?.length === 0 && searchHistoryText" class="no-matches">
            No data found.
        </div>
        <ng-container *ngFor="let message of groupedMessages">
            <!-- Date Header -->
            <div *ngIf="message?.isHeader" class="date-header">
                <span>{{ message?.date }}</span>
            </div>
            <div *ngIf="!message?.isHeader" class="message-container"> 
                <!-- Message from the patient -->
                <div *ngIf="message?.sender?.identifierType === 3" class="spc-from-pharmacist">
                    <div class="spc-your-pharmacist"  *ngIf="hasContent(message)">{{ message?.sender?.userName || 'Patient' }}</div>
                  <ng-container *ngIf="isTransferCardMessage(message?.message); else normalMessage" class="spc-pharmacist-msg">
                    <ng-container *ngIf="getTransferData(message?.message) as transferData">
                        <div class="transfer-card">
                            <p class="transfer-title">Hi, can you please transfer my prescription for</p>
                            <div class="transfer-detail">
                                <i class="fa-solid fa-prescription-bottle-pill icon_styles"></i>
                                <div class="transfer_data">
                                <div class="data_names">Drug Name</div>
                                <div class="data_values">{{ transferData.drugName }}</div>
                                </div>
                            </div>
                            <div class="transfer-detail">
                                <i class="fa-kit fa-pharmacy icon_styles"></i>
                                <div class="transfer_data">
                                <div class="data_names">Pharmacy Name</div>
                                <div class="data_values">{{ transferData.pharmacyName }}</div>
                                </div>
                            </div>
                            <hr/>
                            <div class="transfer-action"
                                (click)="initiateTransfer(transferData.drugId, transferData.pharmacyName, transferData.pharmacyNPI)">
                                Initiate Transfer Now
                            </div>
                        </div>
                    </ng-container>
                    </ng-container>

                    <ng-template #normalMessage>
                          <div class="spc-error-card" *ngIf="isDeletedMessages(message?.message)">
                            <i class="fa-solid fa-ban error-icon"></i>
                            <i>This message was deleted</i>
                        </div>
                        <!-- Normal text message -->
                        <span *ngIf="!isDeletedMessages(message?.message) && !message?.message?.startsWith('\n')"
                              [innerHTML]="parseMessagefromPh(message?.message)">
                        </span>
                        <!-- Normal attachments -->
                        <div *ngIf="message?.imageUrls?.length"
                            class="att-list">
                        </div>
                      <div *ngIf="message?.imageUrls?.length" class="att-list">
                          <div class="att-card" *ngFor="let imgDoc of message.imageUrls">
                            <div class="att-media">
                              <img [src]="imgDoc?.url" alt="Attachment" (click)="openHistoryPreview?.(imgDoc)" (error)="onImgErr($event, imgDoc?.url)" />
                              <button class="att-expand" type="button" aria-label="Expand"
                                      (click)="openHistoryPreview?.(imgDoc); $event.stopPropagation()">
                              <img src="assets/img/enlarge.svg">
                              </button>

                              <div class="att-filebar">
                                <div class="att-filename">{{ imgDoc?.name }}</div>
                               <div>{{imgDoc?.sizeInMb | number: '1.0-2'}} MB</div>
                              </div>
                            </div>

                            <div class="att-secure">
                            <img src="assets/img/shield.svg" class="shield-icon">
                              <span>Securely stored with end-to-end encryption</span>
                            </div>

                            <div class="att-actions">
                             <a href="javascript:void(0)"  class="att-action" (click)="downloadImg(imgDoc)"> 
                              <img src="assets/img/download.svg" class="download-icon"> Download</a>

                               <a href="" class="att-action" (click)="openChatDocModal(imgDoc); $event.preventDefault()">
                                <img src="assets/img/save to.svg">Save to</a>
                            </div>
                          </div>
                        </div>
                    </ng-template>

                    <div class="spc-recieved-date-time"  *ngIf="hasContent(message)">{{ message?.date | date:'h:mm a' }}</div>
                </div>
        
                <!-- Message from the pharmacist -->
                <div *ngIf="message?.sender?.identifierType === 1" class="spc-frm-you">
                    <div class="spc-frm-patient">{{(message?.sender?.userName) ? message?.sender?.userName : pharmacyName}}</div>
                        <div class="spc-frm-msg">
                        <span [innerHTML]="parseMessage(message?.message)"></span>
                    </div>
                    <div class="spc-sent-date-time">
                        {{ message?.date | date:'h:mm a' }}
                        <svg
                            *ngIf="message?.status === 'sent'"
                            class="tick-icon"

                            width="14"
                            height="15"
                            viewBox="0 0 14 15"
                            [attr.fill]="message?.isRead ? '#019F08' : '#9094A0'" 
                            xmlns="http://www.w3.org/2000/svg"
                        ><title>Devlivered</title>
                            <path
                                d="M3.90838 10.788L0.612549 7.49219L1.4438 6.67552L3.92297 9.15469L4.73963 9.97135L3.90838 10.788ZM7.20422 10.788L3.90838 7.49219L4.72505 6.66094L7.20422 9.1401L12.5709 3.77344L13.3875 4.60469L7.20422 10.788ZM7.20422 7.49219L6.37297 6.67552L9.26047 3.78802L10.0917 4.60469L7.20422 7.49219Z"
                            />
                        </svg>
                        <svg
                            *ngIf="message?.status === 'queued'"
                            class="comm-check-icon"
                            xmlns="http://www.w3.org/2000/svg" 
                            height="15" 
                            viewBox="0 -960 960 960" 
                            width="15" 
                            fill="#f7941d">
                            <title>Queued</title>
                            <path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z"/>
                        </svg>
                        <svg
                            *ngIf="message?.status === 'failed'"
                            class="comm-check-icon"
                            xmlns="http://www.w3.org/2000/svg" 
                            height="15" 
                            viewBox="0 -960 960 960" 
                            width="15" 
                            fill="#f6251a">
                            <title>Failed</title>
                            <path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
                        </svg>
                    </div>
                </div>
            </div>
        </ng-container>
        <app-transfer-in *ngIf="openTrnsReqPopup" (ClosePopUpModal)="closeTRxREQPopUpModal($event)" [DrugInformationFrmExtHist]="drugInformation" [PatientDetails]="rxPatientModel" [isFrmPatExternHist]="true" [SourcePharmacyDetails]="sourcePharmacyDetails"> </app-transfer-in>
</div>
<div class="spc-lightbox" *ngIf="isHistoryPreviewOpen">
<div class="spc-lightbox__content" [ngClass]="{'centered_img_preview': isFrmMessegingTab}">
<div class="spc-lightbox__header">
  <div class="spc-lightbox__text">
    <div class="spc-lightbox__title">{{userName}} | {{ previewFilename }} | {{ previewSize }} | {{previewDtTm | date:'short'}}</div>
  </div>

  <div class="spc-lightbox__tools">
<button type="button" class="spc-zoom-btn" (click)="zoomOut()">
  <i class="fa-light fa-magnifying-glass-minus"></i>
</button>
<span class="spc-zoom-val">{{ (zoom * 100) | number:'1.0-0' }}%</span>
<button type="button" class="spc-zoom-btn" (click)="zoomIn()">
  <i class="fa-light fa-magnifying-glass-plus"></i>
</button>

<a href="javascript:void(0)" 
   class="spc-dl-btn" 
   (click)="downloadImg(previewDoc)">
  <img src="assets/img/download.svg" class="download-icon_preview">
</a>


    <!-- <button class="spc-lightbox__close" type="button" aria-label="Close" > -->
      <i class="fa-solid fa-down-left-and-up-right-to-center" (click)="closeHistoryPreview()"></i>
    <!-- </button> -->
  </div>
</div>
   <div class="spc-lightbox__body">
  <div class="spc-lightbox__imgwrap">
    <img [src]="historyPreviewUrl"
         alt="Full preview"
         class="spc-lightbox__image"
         [style.transform]="'scale(' + zoom + ')'"
         style="transform-origin: top center;" />
  </div>
</div>

  </div>
</div>

<ng-template #chatDocTpl let-c="close" let-d="dismiss">
<div class="attach-doc-modal">
  <div class="modal-header">
    <h4 class="modal-title">Attach Document</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross'); closeModal()">
      <span aria-hidden="true" class="close-button">&times;</span>
    </button>
  </div>
  <div class="modal-body edit-patient insurance--body">
    <div class="row">
      <div class="col">
        <table class="table table-hover">
          <tbody>
            <div class="row col-sm-12">
              <div class="height_38 col-3">
                <div class="row">

                  <!-- Patient Info Card -->
                  <div class="patient-info-card mb-3 col-12"  [ngClass]="{'padding_3px_14px': selectedRx}">
                    <div class="patient-info-header">
                      <img src="assets/img/user_icon.svg" alt="user" class="icon-20" />
                      <span class="patient-name">{{ userName | titlecase }}</span>
                    </div>
                    <div class="patient-info-details">
                      <div class="info-item">
                        <img src="assets/img/bday.svg" alt="dob" class="icon-20" />
                        <span>{{ rxPatientModel?.dob }}</span>
                      </div>
                      <div class="info-item" *ngIf="rxPatientModel?.mobile">
                        <img src="assets/img/mobile.svg" alt="phone" class="icon-20" />
                        <span>{{ (rxPatientModel?.mobile ? rxPatientModel?.mobile : "--") | mask:"(000)000-0000" }}</span>
                      </div>
                    </div>
                  </div>


                  <!-- Image Save To -->
                  <div class="col-12">
                    <!-- Image Save To -->
                    <label class="control-label mb-3 custom--input col-sm-12 padding-0" [ngClass]="{'margin_bottom_0 height_0_5rem': selectedRx}">
                      <span>Save Image to</span>
                      <div class="save-to-options" [ngClass]="{'margin_top_5px': selectedRx}">
                        <label class="form-check-inline_Img">
                          <input type="radio" class="form-check-input_ImgDisplay" name="imageSaveTo" id="saveToPatient"
                            [(ngModel)]="selectedSaveTo" value="patient" (ngModelChange)="onSaveToChange($event)" />
                          <span>Patient</span>
                        </label>

                        <label class="form-check-inline_Img right_3rem position-relative">
                          <input type="radio" class="form-check-input_ImgDisplay" name="imageSaveTo" id="saveToRx"
                            [(ngModel)]="selectedSaveTo" (ngModelChange)="onSaveToChange($event)" value="rx" />
                          <span>Rx</span>
                        </label>
                      </div>
                    </label>

                    <!-- Search Rx# (only when Rx is selected) -->
                    <div *ngIf="selectedSaveTo === 'rx'" class="col-12 p-0">
                      <label class="control-label mb-3 custom--input col-sm-12 padding-0">

                        <span>Search Rx#</span>
                        <span class="help--text__danger ms-1">*</span>
                        <div class="rx-search" [ngClass]="{'margin_top_0_5rem': selectedRx}">
                          <input type="text" class="form-control" placeholder="Enter Rx number and press Enter"
                            [(ngModel)]="rxQuery" (keydown.enter)="onSearch()" (keydown.tab)="onSearch()"
                            (input)="onRxInputChange()" [ngClass]="{'error-border': noRxFound}" required />
                          <div *ngIf="noRxFound" class="noRxFound-message">
                            No Rx# found
                          </div>
                          <!-- Dropdown for Rx numbers -->
                          <ul class="rx-dropdown" *ngIf="showDropdown && rxList.length">
                            <li *ngFor="let rx of rxList" (click)="onSelectRx(rx)">
                              {{ rx.PrescNum }}
                            </li>
                          </ul>
                          <!-- Selected Rx info -->
                        </div>
                      </label>
                    </div>
                    <div *ngIf="selectedRx" class="rx-selected-box">
                      <div class="rx-info-text">
                        <div class="rx-number">
                          <img src="assets/img/Rx_icon.svg" alt="rx" class="icon-20" />
                          {{ selectedRx.PrescNum }}
                        </div>
                        <div class="rx-drug margin_top_0_5rem" [ngClass]="{'': selectedRx}">
                          <img src="assets/img/pillbottle.svg" alt="drug" class="icon-20" />
                          {{ selectedRx.Drugfullname }}
                        </div>
                      </div>
                    </div>

                  </div>


                  <!-- Title -->
                  <div class="col-12" [ngClass]="{'top_0_5rem': selectedRx}">
                    <eprx-input [AutoFocus]="true" [MaxLength]="150" [LabelText]="'Title'" [PlaceHolder]="''"
                      [ControlName]="'Name'" [FormGroupName]="docUploadFG" [IsRequired]="true"
                      [InputErrors]="docUploadFG?.controls?.Name?.errors" [ErrorDefs]="{required: 'Required'}"
                      [InputType]="'TEXT'" [MarkAsTouched]="docUploadFG?.controls?.Name?.touched">
                    </eprx-input>
                  </div>

                  <!-- Date -->
                  <div class="col-12" [ngClass]="{'top_0_5rem': selectedRx}">
                    <label class="control-label mb-3 custom--input col-sm-12 padding-0">
                      <span>Date</span>
                      <input class="form-control search--input__box_date" [value]="today" readonly>
                    </label>
                  </div>

                  <!-- Print With Label -->
                  <div class="col-12" [ngClass]="{'top_0_5rem': selectedRx}" [formGroup]="docUploadFG">
                    <input class="form-check-input" type="checkbox" id="printWithLabel"
                      formControlName="PrintWithLabel" />
                    <label class="form-check-label" for="printWithLabel">Print With Label</label>
                  </div>

                  <!-- Subcategory -->
                  <div class="col-12 mt-2 top_0_5rem">
                    <eprx-select [LabelText]="'Subcategory'" [ControlName]="'DocSubCatId'" [FormGroupName]="docUploadFG"
                      [HasMultiple]="false" [HasBindLabel2]="false" [BindLabel]="'Name'" [BindValue]="'Id'"
                      [LabelForId]="'Id'" [List]="subCatDropdownsList" [IsRequired]="true"
                      [InputErrors]="docUploadFG?.controls?.DocSubCatId?.errors" [ErrorDefs]="{required: 'Required'}"
                      [MarkAsTouched]="docUploadFG?.controls?.DocSubCatId?.touched"
                      [FormGroupInvalid]="formGroupInvalid">
                    </eprx-select>
                  </div>

                  <!-- Comments -->
                  <div class="col-12" [formGroup]="docUploadFG">
                    <label class="control-label full--width">
                      <span>Comments</span>
                      <textarea rows="8" cols="50" formControlName="Remarks" maxlength="500"
                        [ngClass]="{ 'comment__box': selectedSaveTo === 'rx', 'height_4rem': selectedRx , 'height_8rem': selectedSaveTo === 'patient' }"  class="custom--text__area"
                        placeholder="Comments"></textarea>
                    </label>
                  </div>

                </div>
              </div>


              <div class="col-9">
                <div class="row">
                  <div class="col-12 chat_preview_height">
                    <!-- image preview -->
                    <div *ngIf="!showEditImage">
                      <lib-ngx-image-zoom [thumbImage]="src" [fullImage]="src" [magnification]="1" [zoomMode]="'hover'"
                        [enableLens]="true" [lensHeight]="100" [lensWidth]="200">
                      </lib-ngx-image-zoom>

                      <!-- pdf preview -->
                      <div *ngIf="addFileType === 'pdf'" class="pdf-container view-sect">
                        <pdf-viewer [src]="innerHtml" [render-text]="true" [fit-to-page]="true" [original-size]="true"
                          [show-borders]="true" [autoresize]="true" [show-all]="false" class="d-block">
                        </pdf-viewer>
                      </div>
                    </div>
                    <app-image-editor-ref [customClass]="'with-margin'" [zoomCustomClass]="'with-margin'"
                      *ngIf="showEditImage" [ImageFile]="uploadedFile"
                      (IsPopUpClosed)="onEditImageClose($event)"></app-image-editor-ref>

                  </div>
                </div>
              </div>
            </div>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer margin_top_n2rem chatbox_footer">
    <button type="button" class="hotkey_success" (click)="saveDocuments()" *ngIf="!editMode"
      [disabled]="selectedSaveTo === 'rx' && (!selectedRx || noRxFound)" appShortcutKey [AltKey]="'s'">
      <span>S</span>SAVE
    </button>
    <button type="button" class="hotkey_success" (click)="editImage()" appShortcutKey [AltKey]="'e'"><span>E</span>Edit
      Image</button>
    <button type="button" class="hotkey_success" (click)="closeModal()" appShortcutKey [AltKey]="'c'">
      <span>C</span>CANCEL
    </button>
  </div>
 </div>
</ng-template>